<div class="w-full bg-gradient-to-r from-[#2402f8cc] to-[#60c0ffcc]">
  <div class="bg-no-repeat bg-cover bg-center">
    <div class="md:flex md:justify-between md:items-center xl:max-w-screen-xl xl:w-full xl:m-auto">
      <div class="relative flex flex-row-reverse md:flex-row gap-x-2 lg:gap-x-8 items-end overflow-y-clip">
        <div
          class="hidden lg:flex items-start mt-20 aspect-square md:w-[20vw] min-w-[30rem] overflow-hidden relative p-12 rounded-full bg-white -ml-12 2xl:-ml-40 md:-mb-48 2xl:-mb-48"
        >
          <img
            ngSrc="./assets/img/giveaway-banner-gift.png"
            alt="gift"
            height="154"
            width="153"
            class="w-full object-contain px-5 -rotate-6"
          />
        </div>
        <div class="p-10 xl:px-0">
          <div class="flex">
            <div class="pb-8 text-white">
              <div
                class="lg:hidden flex items-end aspect-square rounded-full overflow-hidden float-right w-80 -mt-40 -mr-24 bg-white"
              >
                <img
                  ngSrc="./assets/img/giveaway-banner-gift.png"
                  alt="gift"
                  height="113"
                  width="112"
                  class="w-11/12 object-contain pt-0 pr-8 pb-8 pl-4 rotate-[20deg]"
                />
              </div>
              <div class="hidden md:block">
                <div
                  class="text-[2.5rem] font-bold"
                  [innerHTML]="'components.banners.giveaway.desktop.title' | translate"
                ></div>
                <div
                  class="text-lg font-medium"
                  [innerHTML]="'components.banners.giveaway.desktop.subtitle' | translate"
                ></div>
              </div>
              <div class="block md:hidden">
                <div
                  class="text-2xl font-bold"
                  [innerHTML]="'components.banners.giveaway.mobile.title' | translate"
                ></div>
                <div
                  class="font-medium text-base"
                  [innerHTML]="'components.banners.giveaway.mobile.subtitle' | translate"
                ></div>
              </div>
            </div>
          </div>
          <div class="md:flex items-center px-6 py-4 text-white border border-solid border-white rounded-2xl text-base">
            <div class="pb-4 md:pb-0 md:pr-4 leading-8">
              <div
                class="font-medium hidden md:block"
                [innerHTML]="'components.banners.giveaway.desktop.explanation' | translate"
              ></div>
              <div
                class="font-medium block md:hidden"
                [innerHTML]="'components.banners.giveaway.mobile.explanation' | translate"
              ></div>
            </div>
            <div class="flex gap-x-4">
              <a href="https://apps.apple.com/be/app/totalenergies-power-gas/id1601217446" target="_blank">
                <img
                  ngSrc="./assets/img/button-apple-store.svg"
                  height="60"
                  width="204"
                  alt="apple store"
                  class="h-16"
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=be.totalenergies.mytotalenergies" target="_blank">
                <img
                  ngSrc="./assets/img/button-google-play.svg"
                  height="60"
                  width="204"
                  alt="google play"
                  class="h-16"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
